import { render, staticRenderFns } from "./StockTransferAddProductModal.vue?vue&type=template&id=12302304&scoped=true"
import script from "./StockTransferAddProductModal.vue?vue&type=script&lang=js"
export * from "./StockTransferAddProductModal.vue?vue&type=script&lang=js"
import style0 from "./StockTransferAddProductModal.vue?vue&type=style&index=0&id=12302304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12302304",
  null
  
)

export default component.exports